/* eslint-disable no-underscore-dangle */
import http from '@/tool/http/http'

function service() {
  const Services = {}
  // 根据学号查询学生
  Services._getStudent = sn => http.GET(`/api/common/getStudent/${sn}`)
  // 根据工号查询用户
  Services._getUser = sn => http.GET(`/api/common/getUser/${sn}`)
  // 只能查询教师
  Services._checkTeacher = sn => http.GET(`/api/common/checkTeacher/${sn}`)
  // 根据sn获取学生银行卡信息
  Services._getStudentBankCard = sn => http.GET(`/api/common/getStudentBankCard/${sn}`)
  return Services
}
export default service
